import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ListView from './ListView';
import {GigCardContextProvider} from '../shared';
import addMediaListener from '../utils/mediaListener';
import CollectionStore from '../store/collection';
import translations from '../translations.en.json';
import '@fiverr/globals';
import './style.scss';

class ListViewCard extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            unmounting: false,
            collections: false,
            isMobile: this.props.isMobile
        };

        this.updateCollections = this.updateCollections.bind(this);

        i18n.add(translations);
    }

    componentDidMount() {
        if (this.props.user) {
            this.getCollections().then((json) => { this.setState({collections: json}); });
        }

        this.removeMediaListener = addMediaListener('(min-width: 600px)', (mq) => this.setState({ isMobile: !mq.matches }));
    }

    componentWillUnmount() {
        this.removeMediaListener && this.removeMediaListener();
    }

    updateCollections(collections) {
        this.setState({ collections });
    }


    getCollections() {
        const {gigs, user} = this.props,
            hearts = gigs.map((gig) => gig.gig_id);

        if (!user) {
            return;
        }

        return CollectionStore.getCollections(hearts).then((json) => { this.setState({collections: json}); return json; });
    }

    render() {
        const { gigs, user, responsiveGrid, context = {} } = this.props,
            { collections, isMobile } = this.state,
            cardTypeVal = 'list';

        return (
            <GigCardContextProvider value={{ cardType: cardTypeVal, collections, user, ...context }}>
                <div className="react-gig-cards-slider list-view-slider slider-hider cf">
                    {gigs.map((gig, i) => (
                        <ListView key={`list-view-${i}`}
                            isMobile={isMobile}
                            gig={gig}
                            user={user}
                            responsiveGrid={responsiveGrid}
                            context={context}
                            updateCollections={this.updateCollections}/>
                    ))}
                </div>
            </GigCardContextProvider>
        );
    }
}

ListViewCard.propTypes = {
    user: PropTypes.object,
    gigs: PropTypes.array,
    responsiveGrid: PropTypes.bool,
    isMobile: PropTypes.bool,
    context: PropTypes.shape({
        pageCtxId: PropTypes.string,
        refCtxId: PropTypes.string
    })
};

ListViewCard.defaultProps = {
    responsiveGrid: false
};

export default ListViewCard;



// WEBPACK FOOTER //
// ./src/list_view_card/index.js